import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BreadcrumbData } from './breadcrumb.component';

@Injectable({ providedIn: 'root' })

export class BreadcrumbService {
  private breadcrumbLabels = new BehaviorSubject<Record<string, string>>({});
  private newBreadcrumb = new BehaviorSubject<BreadcrumbData[]>([]);

  breadcrumbLabels$ = this.breadcrumbLabels.asObservable();
  newBreadcrumb$ = this.newBreadcrumb.asObservable();

  updateBreadcrumbLabels(labels: Record<string, any>): void {
    this.breadcrumbLabels.next(labels);
  }

  updateBreadcrumb(breadcrumbs: BreadcrumbData[]): void {
    this.newBreadcrumb.next(breadcrumbs);
  }
}
